export const IMPORT_STEPS = ['file', 'columns', 'check', 'references', 'groups', 'optionLists', 'summary'];
